<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <login-card style="margin-left:200px;" header-color="primary">
        <h3 slot="title" class="title"><br />Password Reset</h3>

        <p slot="subheader" style="font-size: .8rem; margin: 0px;">Forgot your password? Don't worry.</p>
        <p slot="subheader2" style="font-size: .8rem; margin: 0px;">We'll send you an email to reset your password.</p>

        <p slot="description" class="description" />

        <md-field slot="inputs" :class="[
            { 'md-valid': !errors.has('email') && emailTouched },
            { 'md-form-group': true },
            { 'md-error': errors.has('email') && emailTouched }
          ]">
          <md-icon>mail_outline</md-icon>
          <label>Email</label>
          <md-input
            style="width: inherit;"
            v-validate="emailValidation"
            v-model="email"
            data-vv-name="email"
            type="email"
            name="email"
          />
          <slide-y-down-transition>
            <md-icon style="padding: 0;" v-show="errors.has('email')" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('email') && emailTouched" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>

        <span slot="footer" align="Right" style="margin-right: 25px;">
          <a>&nbsp;</a>
        </span>

        <md-button style="width: 130px;" slot="footer" class="md-primary " @click="validateMember"> Reset Password </md-button>

        <span slot="footer" align="Center" style="margin-left: 5px;width: 130px;">
          <router-link to="/" style="font-size: .85rem; color: #000000de;">Cancel</router-link>
        </span>
      </login-card>
    </div>
    <loader :is-visible="isLoading" />
  </div>
</template>

<script>
import { LoginCard } from "@/components"
import Swal from "sweetalert2"
import { SlideYDownTransition } from "vue2-transitions"
import loader from "@/components/GlobeChek/loader.vue"

export default {
  components: {
    LoginCard,
    loader
  },
  data() {
    return {
      email: null,
      password: null,
      emailValidation: {
        required: true,
        min: 6,
        regex: "^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"
      },
      emailTouched: false,
      isLoading: false
    }
  },
  mounted() {},
  methods: {
    validateMember() {
      this.emailTouched = true;
      return this.$validator.validateAll().then(valid => {
        if (!valid) {
          return;
        }

        this.isLoading = true;
        const url = process.env.VUE_APP_URL + "/reset-password/" + this.email
        const data = null
        const config = { headers: { "Content-Type": "application/json" } }
        window.axios
          .post(url, data, config)
          .then(() => {
            this.successMsg()
            this.$router.push("/")
          })
          .catch(errors => {
            console.log(errors);
            this.failureMsg()
          }).finally(()=>{
            this.isLoading = false;
          })
      })
    },
    successMsg() {
      Swal.fire({
        title: "Reset request sent.",
        text: "Please Check Your Email for Instructions.",
        timer: 3000,
        showConfirmButton: false,
        buttonsStyling: false,
        confirmButtonClass: "md-button md-success",
        type: "success"
      })
    },
    failureMsg() {
      Swal.fire({
        title: "Error",
        text: "It was not possible to send the reset email. Please try again later",
        type: "error",
        confirmButtonClass: "md-button md-info",
        buttonsStyling: false,
        timer: 3000
      })
    }
  }
}
</script>

<style></style>
